/** Filled silhouettes for the home menu, drawn on a shared 32px grid. */
type HomeMenuIconName = 'study' | 'new-game' | 'create-room' | 'enter-room' | 'key' | 'cpu' | 'learn' | 'puzzle' | 'archive' | 'mix';

const SHAPES: Record<HomeMenuIconName, string> = {
  key: 'M10 4a8 8 0 1 0 7.42 11H22v5h4v-5h4V9H17.42A8 8 0 0 0 10 4ZM10 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z',
  'create-room': 'M17 3h11v26H17v-3h8V6h-8V3ZM8 10h4v6h6v4h-6v6H8v-6H2v-4h6v-6Z',
  mix: 'M14 9a6 6 0 1 1-12 0 6 6 0 0 1 12 0ZM23 2l6 4 2 12H15l2-12 6-4ZM4 20h3v3h2v-3h3v3h2v-3h3v7H4v-7ZM5 28h11v3H5v-3ZM30 25a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z',
  'new-game': 'M16 8a5 5 0 1 1-10 0 5 5 0 0 1 10 0ZM3 26v-3c0-5 3.5-8 8-8s8 3 8 8v3H3ZM27 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM21 26v-3c0-2.8-.8-5.1-2.2-6.9A8 8 0 0 1 23 15c4 0 7 3 7 7v4h-9Z',
  'enter-room': 'M17 3h11v26H17v-6h3v3h5V6h-5v3h-3V3ZM3 13h10V8l10 8-10 8v-5H3v-6Z',
  cpu: 'M14.5 3h3v4H23a4 4 0 0 1 4 4v13a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4h5.5V3ZM11 13a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM21 13a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM11 21v3h10v-3H11ZM1 13h3v10H1V13ZM28 13h3v10h-3V13Z',
  learn: 'M3 5c5-1 9 0 12 3v21c-3-3-7-4-12-3V5ZM17 8c3-3 7-4 12-3v21c-5-1-9 0-12 3V8Z',
  study: 'M7.5 10.71A4 4 0 1 1 10.5 10.71V15.5H17.5Q21.5 15.5 21.5 11.5V10.71A4 4 0 1 1 24.5 10.71V11.5Q24.5 18.5 17.5 18.5H10.5V21.29A4 4 0 1 1 7.5 21.29Z',
  puzzle: 'M5 5h7V4a4 4 0 0 1 8 0v1h7v8h-2a3 3 0 1 0 0 6h2v8h-8v-2a3 3 0 1 0-6 0v2H5v-8H4a4 4 0 0 1 0-8h1V5Z',
  archive: 'M5 3h22v5H5V3ZM3 10h26v19H3V10ZM11 14v3h10v-3H11Z',
};

export function HomeMenuIcon({ name }: { name: HomeMenuIconName }) {
  return (
    <svg className="home-menu-icon" width={28} height={28} viewBox="0 0 32 32"
      fill="currentColor" aria-hidden="true" focusable="false">
      <path d={SHAPES[name]} fillRule="evenodd" />
    </svg>
  );
}
